import React from 'react'; 
import JournalCard from './JournalCard';


const Journal = () => { 

    const hrefPrefix = '/journal'
    const cards = [
        {
            title: 'Improving Language Model Responses with Stacked State-of-the-Art Methods',
            create_date: 'September 13, 2025',
            update_date: 'September 13, 2025',
            href: hrefPrefix + '/lm_resp_with_stacked_sota_methods'
        },
        {
            title: 'Enhancing Constitutional AI with PEFT, RAG, or Few-Shot Learning',
            create_date: 'September 13, 2025',
            update_date: 'September 13, 2025',
            href: hrefPrefix + '/enhancing_const_ai'
        }
    ]
    
    return (
        <div className="h-center top-space bottom-space">
            <div className="w-60">
                <p className="f1 fw7 text-dark mv0">
                    <span className="fas fa-book"></span> Journal 
                </p>
                <p>In this journal, I share ideas I've developed around generative AI concepts (like PEFT, RLHF, ReAct, Constitutional AI), highlighting my depth of knowledge, curiosity, and application-driven mindset regarding innovations in the generative AI space.</p>
                {cards.map((card, i) => {
                    return (
                        <div>
                            <hr />
                            <JournalCard 
                                key={i}
                                title={card.title}
                                create_date={card.create_date}
                                update_date={card.update_date}
                                href={card.href}
                            />
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default Journal; 